import { Outlet } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import SurveyDetailHeader from './Components/Header'

import useViewModel from './ViewModel'

const SurveyDetailView: React.FC = () => {
  const { pages, survey } = useViewModel()

  return (
    <ViewPageTitle>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <SurveyDetailHeader pages={pages} survey={survey} />

      <Outlet />
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/survey',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'แบบสำรวจ',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        แบบสำรวจ
      </PageTitle>

      {children}
    </>
  )
}

export default SurveyDetailView
